export const WBTextType = {
  signUpBanner: "signUpBanner",
  docUploadBanner: "docUploadBanner",
  approvalPendingBanner: "approvalPendingBanner",
  promoCodeAvailableBanner: "promoCodeAvailableBanner"
};